// extracted by mini-css-extract-plugin
module.exports = {"inputForm":"styles-module--inputForm--1YRi4","headingForm":"styles-module--headingForm--12h6T","button":"styles-module--button--1-rsF"};